<div class="load-detail-sidebar">
    <ng-container *ngIf="load == null && loading; else filledLoadDetailSidebar">
        <app-loader-logo></app-loader-logo>
    </ng-container>
    <ng-template #filledLoadDetailSidebar>
        <div class="load-detail-sidebar-buttons">
            <button class="btn btn-outline" (click)="goBack()">
                <i class="fa fa-close" ></i>&nbsp;<span [i18n]="'bluechat.detail.close'"></span>
            </button>
            <button class="btn btn-outline" (click)="refreshLoad()">
                <i [ngClass]="{'fa-spin': loading}" class="fa fa-refresh" ></i>&nbsp;<span [i18n]="'bluechat.detail.refresh'"></span>
            </button>
        </div>
        <div class="load"><span class="load-label" [i18n]="'bluechat.detail.load.load-number'"></span>#{{load.loadNumber}}</div>
        <div class="load-detail-sidebar-content">
            <div class="row load-status">
                <div class="col-xs-12">
                    <app-bluechat-load-status [status]="load.status"></app-bluechat-load-status>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 load-detail-sidebar-info">
                    <label><span [i18n]="'bluechat.detail.load.carrier'"></span>:</label>
                    <h3><a class="badge badge-link badge-size-md cmaweb-link" [href]="link.goToCarrierName(load.carrierName, isSelfCarrier)" target="_blank">{{load.carrierName}}</a></h3>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12 load-detail-sidebar-info">
                    <label>
                        <i class="fa fa-truck"></i>&nbsp;
                        <span [i18n]="'bluechat.detail.load.vehicle'"></span>:
                    </label>
                    <h3>{{load.vehicle || '-'}}</h3>
                </div>
                <div class="col-xs-12 load-detail-sidebar-info">
                    <label><span [i18n]="'bluechat.detail.load.number-stop'"></span>: </label>
                    <h3>{{load.stopNumber}}</h3>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12 load-detail-sidebar-info">
                    <label><span [i18n]="'bluechat.detail.load.total-weight'"></span>: </label>
                    <h3>{{load.weight}}</h3>
                </div>
                <div class="col-xs-12 load-detail-sidebar-info">
                    <label><span [i18n]="'bluechat.detail.load.total-pieces'"></span>:</label>
                    <h3>{{load.pieces}}</h3>
                </div>
                <div class="col-xs-12 load-detail-sidebar-info">
                    <label><span [i18n]="'bluechat.detail.load.total-distance'"></span>:</label>
                    <h3>{{load.totalDistance | blueyonderDistance }}</h3>
                </div>

                <!-- customer time window -->
                <div class="col-xs-12 load-detail-sidebar-info flex-column">
                    <label><span [i18n]="'bluechat.detail.load.customer-time-window.label'"></span>:</label>
                    <div class="m-l-md">
                        <h3><span [i18n]="'bluechat.detail.load.customer-time-window.start'"></span>: {{load.lastStopLatestFromDeliveryDateTime | date: 'MMM d, y, HH:mm' }}</h3>
                        <h3><span [i18n]="'bluechat.detail.load.customer-time-window.end'"></span>: {{load.lastStopEarliestToDeliveryDateTime | date: 'MMM d, y, HH:mm' }}</h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="load-detail-sidebar-content _scroll">
            <div *ngFor="let delivery of load.deliveries"
                 class="delivery-summary">
                <div class="row">
                    <div class="col-xs-6 delivery-summary-info _col">
                        <label><span [i18n]="'bluechat.detail.delivery.delivery-number'"></span>: </label>
                        <h3>#{{delivery.deliveryNumber}}</h3>
                    </div>
                    <div class="col-xs-6 text-right">
                        <app-bluechat-delivery-status [displayEta]="false" [status]="delivery.status"></app-bluechat-delivery-status>
                    </div>
                </div>

                <button *ngIf="delivery.tripId != null" class="btn btn-i btn-light" (click)="navigateToLoadTracking(delivery)">
                    <i class="fas fa-map-marker-alt m-r-xxs"></i>&nbsp;
                    <span [i18n]="'bluechat.detail.delivery.load-tracking'"></span>
                </button>
            </div>
        </div>
    </ng-template>
</div>

<div class="load-detail-container">
    <ng-container *ngIf="load == null && loading; else filledLoadDetailContainer">
        <app-loader-logo></app-loader-logo>
    </ng-container>
    <ng-template #filledLoadDetailContainer>
        <app-bluechat-delivery-detail  *ngFor="let delivery of load.deliveries"
                                       [delivery]="delivery"
                                       (createNote)="transformToLoadAndEmit(delivery)"
                                       [userCanCreateNote]="userCanCreateNote"
                                       [loadStatusAllowNoteCreation]="loadStatusAllowNoteCreation"
                                       [loadStatus]="load.status"
                                       [carrierHasBluechat]="carrierHasBluechat">
        </app-bluechat-delivery-detail>
    </ng-template>
</div>

<ng-template #noteCreationModal>
    <bluechat-note-creation
            [deliveries]="[bluechatDelivery]"
            [userBluechatConfig]="userBluechatConfig">
    </bluechat-note-creation>
</ng-template>
